// extracted by mini-css-extract-plugin
module.exports = {"subTitle_placeholder":"SubTitle_subTitle_placeholder__1e3t8","subTitleBold":"SubTitle_subTitleBold__3UDqS"};